import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const TagWrapper = styled.div`
  padding: 3.5px 8px;
  margin: 0px 4px 4px 0px;
  align-self: flex-end;
  background: ${themeGet('colors.error.default')};
  border-radius: 6px;
`;

const TagText = styled.span`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  color: white;
`;

const IncompleteTagComponent = () => (
  <TagWrapper>
    <TagText>Incomplete</TagText>
  </TagWrapper>
);

export default IncompleteTagComponent;
